import React from 'react';

const LanguageSelector = ({ lang, setLang }) => {
  return (
    <select
  className="language-selector__dropdown"
  value={lang}
  onChange={(e) => setLang(e.target.value)}
>
  <option value="en">English</option>
  <option value="es">Español</option>
</select>
  );
};

export default LanguageSelector;